import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { CART_URL } from './constants';
import { trackAddToCart } from '../utils/metaPixel';
export function AlertBar() {
  return <div className="sticky top-0 z-50 w-full bg-plum text-cream" data-id="element-16" data-mp="3onsulfuojepp">
      <a href={CART_URL} onClick={trackAddToCart} className="flex items-center justify-center gap-2 px-4 py-2.5 text-center text-xs font-medium tracking-wide transition-colors hover:bg-[#4a2231] sm:text-sm" data-id="element-17" data-mp="3opncelanmqpk">
        <SparklesIcon className="h-4 w-4 shrink-0 text-gold-soft" data-id="element-18" data-mp="p8fbbsqi0e52" />
        <span data-id="element-19" data-mp="p6l0565140e6">
          <span className="font-bold text-gold-soft" data-id="element-20" data-mp="b8whm4yfp5ca">50% OFF por tiempo limitado</span>
          {' '}— Empezá hoy en UGC y llegá a tus primeros USD 1.000
        </span>
      </a>
    </div>;
}